import partnerAxios from "./partnerAxios";

// ─── Auth ────────────────────────────────────────────────────────────────
export const sendRegisterOtp = (email) => partnerAxios.post("/partner/send-register-otp", { email });
export const registerPartner = (payload) => partnerAxios.post("/partner/register", payload);
export const loginPartner = (email, password) => partnerAxios.post("/partner/login", { email, password });

// ─── Profile ─────────────────────────────────────────────────────────────
export const getProfile = () => partnerAxios.get("/partner/profile");
export const updateProfile = (payload) => partnerAxios.patch("/partner/profile", payload);
export const getProfileCompletion = () => partnerAxios.get("/partner/profile-completion");

// ─── Services ────────────────────────────────────────────────────────────
// Note: /partner/services has no multer middleware server-side (only /partner/packages does, for
// image uploads) — these two send/expect a plain JSON body, not multipart/form-data.
export const listServices = () => partnerAxios.get("/partner/services");
export const createService = (payload) => partnerAxios.post("/partner/services", payload);
export const updateService = (id, payload) => partnerAxios.patch(`/partner/services/${id}`, payload);
export const deleteService = (id) => partnerAxios.delete(`/partner/services/${id}`);

// ─── Packages ────────────────────────────────────────────────────────────
// Create goes through multer (images upload) so it must be sent as multipart/form-data (pass a
// FormData instance — axios sets the multipart boundary header automatically). Update has no
// multer server-side, so it takes a plain JSON payload like updateService above.
export const listPackages = () => partnerAxios.get("/partner/packages");
export const createPackage = (formData) => partnerAxios.post("/partner/packages", formData);
export const updatePackage = (id, payload) => partnerAxios.patch(`/partner/packages/${id}`, payload);
export const deletePackage = (id) => partnerAxios.delete(`/partner/packages/${id}`);

// ─── Leads / Quotes ──────────────────────────────────────────────────────
export const listLeads = () => partnerAxios.get("/partner/leads");
export const submitQuote = (travelRequestId, payload) => partnerAxios.post(`/partner/leads/${travelRequestId}/quote`, payload);
export const listQuotes = () => partnerAxios.get("/partner/quotes");
export const getQuoteDetail = (id) => partnerAxios.get(`/partner/quotes/${id}`);

// ─── Bookings ────────────────────────────────────────────────────────────
export const listBookings = () => partnerAxios.get("/partner/bookings");

// ─── Ledger / Earnings ───────────────────────────────────────────────────
export const getLedger = () => partnerAxios.get("/partner/ledger");
export const getEarningsSummary = () => partnerAxios.get("/partner/earnings-summary");

// ─── Settlements ─────────────────────────────────────────────────────────
export const requestSettlement = (amount) => partnerAxios.post("/partner/settlements/request", { amount });
export const listSettlements = () => partnerAxios.get("/partner/settlements");

// ─── Reviews (public route, read with the partner's own id) ──────────────
export const getPartnerReviews = (partnerId) => partnerAxios.get(`/marketplace/partners/${partnerId}/reviews`);

// ─── Disputes ────────────────────────────────────────────────────────────
export const listDisputes = () => partnerAxios.get("/partner/disputes");
export const raiseDispute = (bookingId, payload) => partnerAxios.post(`/partner/bookings/${bookingId}/disputes`, payload);

// ─── Chat (per travel request lead) ───────────────────────────────────────
export const listMessages = (travelRequestId) => partnerAxios.get(`/partner/leads/${travelRequestId}/messages`);
export const sendMessage = (travelRequestId, text) => partnerAxios.post(`/partner/leads/${travelRequestId}/messages`, { text });

// ─── Offers / Coupons (own-scoped) ────────────────────────────────────────
export const listMyCoupons = () => partnerAxios.get("/partner/coupons");
export const createMyCoupon = (payload) => partnerAxios.post("/partner/coupons", payload);
export const updateMyCoupon = (id, payload) => partnerAxios.patch(`/partner/coupons/${id}`, payload);
export const deleteMyCoupon = (id) => partnerAxios.delete(`/partner/coupons/${id}`);

// ─── Referrals ───────────────────────────────────────────────────────────
export const getMyReferrals = () => partnerAxios.get("/partner/referrals");
